







import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import ReportList from "@/components/report/ReportList.vue";
import Order from "@/models/order/Order";

@Component({
	components: {ReportList, AsiContentContainer}
})
export default class OrderTabReports extends Vue {

	@Prop({type: Object, required: true})
	public order!: Order;

}
